import { makeRequest } from 'utils/requestLogger';

export default (liveID) =>
  makeRequest('put', `/api/live_discussions/${liveID}/toggle-audio`);



// WEBPACK FOOTER //
// ./src/app/services/liveDiscussion/toggleDiscussionAudio.js